import { render, staticRenderFns } from "./JoszakiPill.vue?vue&type=template&id=d0335142"
import script from "./JoszakiPill.vue?vue&type=script&lang=js"
export * from "./JoszakiPill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports